import Card from '@/components/atoms/Card';
import ImageStrapi, {
  ImageStrapiProps,
} from '@/components/atoms/Image/ImageStrapi';
import LinkButton from '@/components/atoms/LinkButton';
import { LinkButtonStrapiProps } from '@/components/atoms/LinkButton/LinkStrapi';
import { transformFromCMSLink } from '@/components/atoms/LinkButton/utils';

import { passPhTracker } from '@/integrations/trackingScripts/utils';

export type IconLinkItem = {
  image: ImageStrapiProps;
  link: LinkButtonStrapiProps;
  title?: string;
};

export type IconLinkCardProps = {
  item: IconLinkItem;
  className?: string;
};

export function IconLinkCard({ item }: IconLinkCardProps) {
  const { image, link, title } = item;
  const { href, openInNewTab, target } = transformFromCMSLink(link);
  const label = link.text || title || image.altText || 'Open link';

  return (
    <LinkButton
      href={href}
      openInNewTab={openInNewTab}
      target={target}
      noStyles
      aria-label={label}
      data-tracker-component='icon-link-card'
      {...passPhTracker(link.phTracker)}
    >
      <Card
        roudnessLevel='l'
        padSize='m'
        classNames={{
          root: 'dark:bg-gray-dark-900 dark:border-gray-dark-700',
        }}
      >
        <ImageStrapi
          block={image}
          width={32}
          height={32}
          inner={{
            classNames: {
              container: 'size-8 shrink-0',
            },
          }}
        />
      </Card>
    </LinkButton>
  );
}
